<template>
  <button type="button" class="icon-button" :class="customClass" :disabled="disabled" @click="handleClick" :data-bs-toggle="modal" :data-original-title="dataTitle" :data-bs-target="modalId">
    <i :class="iconClass">
      <font-awesome-icon :icon="icon" :size="iconSize" />
    </i>
  </button>
</template>

<script>
export default {
  name: 'Button',
  inheritAttrs: false,
  props: {
    disabled: {
      type: Boolean,
      default: false
    },

    icon: {
      type: Array,
      default: ['fas', 'times']
    },

    modal: {
      type: String,
      default: ''
    },

    dataTitle: {
      type: String,
      default: ''
    },

    modalId: {
      type: String,
      default: ''
    },

    customClass: {
      type: Array,
      default: ['bg-info']
    },

    iconClass: {
      type: Array,
      default: ['icon-style']
    },

    iconSize: {
      type: String,
      default: "xl"
    }
  },

  methods: {
    handleClick() {
      this.$emit('click');
    }
  }
};
</script>

<style scoped>
.icon-button {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  padding: 5px;
  margin-left: 10px;
}

.icon-style {
  color: white;
}
</style>